import { Component } from '@angular/core';
import { RidDiceOverlay } from '../rid-dice-overlay/rid-dice-overlay';
import { RidExpressionOverlay } from '../rid-expression-overlay/rid-expression-overlay';

@Component({
  selector: 'rid-mechanic-background',
  imports: [RidExpressionOverlay, RidDiceOverlay],
  templateUrl: './rid-mechanic-background.html',
  host: {
    class: 'contents',
  },
})
export class RidMechanicBackground {}
